import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverComponent } from './component/popover/popover.component';

import { OverlayPanelModule } from 'primeng/overlaypanel';

@NgModule({
  declarations: [PopoverComponent],
  imports: [
    CommonModule,
    OverlayPanelModule
  ],
  exports: [PopoverComponent]
})
export class PopoverModule { }
